import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IGetSnoozeReason, IGetSnoozeReasonKeys } from '../model/editSnoozeInfo';

const getSnoozeReasonKey = (keys: IGetSnoozeReasonKeys): [string, number] => [
  'getSnoozeReason',
  keys.actionItemId,
];

const getSnoozeReasonFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof getSnoozeReasonKey>, number>) => {
  return apiClient.get<{ data: IGetSnoozeReason }>(
    `${APP_API_URL_V2}fsd/action-item/${queryKey[1]}/snooze-reason`,
  );
};

const getSnoozeReasonSelect = ({ data }: AxiosResponse<{ data: IGetSnoozeReason }>) => data.data;

export const useGetSnoozeReasonQuery = (keys: IGetSnoozeReasonKeys) => {
  return useQuery({
    queryKey: getSnoozeReasonKey(keys),
    queryFn: getSnoozeReasonFn,
    select: getSnoozeReasonSelect,
    staleTime: 0,
  });
};
